var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDebit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 17,
    viewBox: "0 0 26 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9494ED",
    d: "M23.108 15.944H1.676C.75 15.944 0 15.194 0 14.268V1.675C0 .75.75 0 1.676 0h21.432c.925 0 1.675.75 1.675 1.675v12.593c0 .926-.75 1.675-1.675 1.675",
    transform: "translate(.095 .882)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6D5990",
    d: "M21.528 12.538H3.255c-.666 0-1.205-.539-1.205-1.204 0-.666.54-1.205 1.205-1.205h18.273c.665 0 1.204.539 1.204 1.205 0 .665-.539 1.204-1.204 1.204",
    transform: "translate(.095 .882)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E3C2F0",
    d: "M16.085 12.538H3.255c-.665 0-1.205-.539-1.205-1.204 0-.666.54-1.205 1.205-1.205h12.83c.665 0 1.204.539 1.204 1.205 0 .665-.54 1.204-1.204 1.204",
    transform: "translate(.095 .882)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDebit);
export default __webpack_public_path__ + "static/media/debit.f9e52133a2de4ad9ff64bf5c6f70bc6c.svg";
export { ForwardRef as ReactComponent };